import { type FC, useEffect, useRef } from 'react'
import { getIncodeClient } from '@egw/risk-service'
import { Logger } from '@egw/logger'

const log = new Logger('DocV')

interface BackIdProps {
  session: { token: string }
  onSuccess: (result: any) => void
  onError?: (error: any) => void
}

export const BackId: FC<BackIdProps> = ({ session, onSuccess, onError }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isMounted = useRef(false)

  useEffect(() => {
    if (isMounted.current || !session || !containerRef.current) {
      return
    }

    log.info('BackId: Starting camera render')

    getIncodeClient().renderCamera('back', containerRef.current, {
      onSuccess: (result) => {
        onSuccess(result)
      },
      onError: (error) => {
        log.error('BackId: Error during camera rendering', error)
        if (onError) {
          onError(error)
        }
      },
      token: session,
      numberOfTries: -1,
      showTutorial: true,
      fullScreen: false,
    })

    isMounted.current = true
  }, [onSuccess, onError, session])

  return <div ref={containerRef} />
}
